export default function getThrottle(immediate = true) {
  let throttler = undefined;
  let throttling = false;

  if (immediate) {
    return function(callback, delay) {
      if (throttling) {
        window.clearTimeout(throttler);

        throttler = window.setTimeout(() => {
          callback();
          throttling = false;
        }, delay);
      } else {
        callback();
        throttling = true;

        throttler = window.setTimeout(() => {
          throttling = false;
        }, delay);
      }
    };
  }

  return function(callback, delay) {
    if (throttling) {
      window.clearTimeout(throttler);
    } else {
      throttling = true;
    }

    throttler = window.setTimeout(() => {
      callback();
      throttling = false;
    }, delay);
  };
}
